import { Grid2 } from "@mui/material";
import logo from './logo.png';
import InnerLink from "../InnerLink";
import { PAGE_LIST } from "../../pages";

import classes from './index.module.scss';

const Logo = () => {
  return (
    <Grid2>
      <InnerLink noUnderline href={PAGE_LIST.APPROVAL}>
        <img src={logo} alt='GHMT' title="GHMT logo" className={classes.logo} />
      </InnerLink>
    </Grid2>
  )
}

export default Logo;